import { Card } from 'primereact/card';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import PropTypes from 'prop-types';
import React from 'react';
import { withTranslation } from 'react-i18next';
import BaseDialogContainer from '../baseContainers/BaseDialogContainer';
import { ActionButton } from '../components/ActionButton';
import BannerComponent from '../components/BannerComponent';
import DivContainer from '../components/DivContainer';
import { Steps } from '../components/StepsComponent';
import TooltipComponent from '../components/TooltipComponent';
import InputCheckboxComponent from '../components/inputs/InputCheckboxComponent';
import InputDropdownComponent from '../components/inputs/InputDropdownComponent';
import InputNumberComponent from '../components/inputs/InputNumberComponent';
import InputRadioButtonComponent from '../components/inputs/InputRadioButtonComponent';
import InputTextComponent from '../components/inputs/InputTextComponent';
import OrderCardModel from '../model/OrderCardModel';
import AccountService from '../services/AccountService';
import CardOrderService from '../services/CardOrderService';
import CardOrderTemplateService from '../services/CardOrderTemplateService';
import CardAgreementTermDialog from './CardAgreementTermDialog';
import SettingService from '../services/SettingService';

class CardOrderTemplateDialog extends BaseDialogContainer {
    constructor(props) {
        super(props, new CardOrderTemplateService());
        this.cardOrderService = new CardOrderService();
        this.accountService = new AccountService();
        this.settingService = new SettingService();
        this.state = {
            elementId: props.elementId,
            element: new OrderCardModel(),
            viewMode: this.props.viewMode,
            activeIndex: 0,
            cardKindOpt: [
                {enumValue: 'FIRM', label: props.t('EcCardKind.FIRM')},
                {enumValue: 'VEHICLE', label: props.t('EcCardKind.VEHICLE')},
                {enumValue: 'VEHICLE_PERSON', label: props.t('EcCardKind.VEHICLE_PERSON')},
                {enumValue: 'PERSON', label: props.t('EcCardKind.PERSON')},
            ],
            mpkTooltipVisible: false,
            agreementTermDialog: false,
            selectedSelectableItem: undefined,
            acceptedTermsList: [],
        };
        this.handlePrevBack = this.handlePrevBack.bind(this);
        this.changeRequiredByCardKind = this.changeRequiredByCardKind.bind(this);
        this.handleChangeStep = this.handleChangeStep.bind(this);
        this.handleShowTooltip = this.handleShowTooltip.bind(this);
        this.handleHideTooltip = this.handleHideTooltip.bind(this);
        this.renderFleetGoodGroupLimit = this.renderFleetGoodGroupLimit.bind(this);
        this.onIndexTemplate = this.onIndexTemplate.bind(this);
    }

    initBeforeSetElement() {
        this.settingService.getValue('PACKAGE_TRACKING_URL').then((resp) =>
            this.setState({
                packageTrackingUrl: resp.value,
            })
        );
        this.settingService
        .getVehicleTypes()
        .then((vehicleTypeOpt) => {
            if (this._isMounted) {
                this.setState({
                    vehicleTypeOpt,
                });
            }
        })
        .catch(() => {this.showErrorMessage("Nie udało się pobrać listy typów pojazdów")});

    }

    handleShowTooltip(ev) {
        this.setState({mpkTooltipVisible: true}, () => {
            const tooltipEl = document.getElementById('mpk-tooltip');
            const icoEl = document.getElementById('ico_help_input_label_blue');
            // let pos_y = ev.pageY - tooltipEl.getBoundingClientRect().height - 15;
            let pos_y = icoEl.getBoundingClientRect().y - tooltipEl.getBoundingClientRect().height - 15;
            // if (pos_y < 0) {
            //     pos_y = ev.pageY + 15;
            // }
            tooltipEl.style.bottom = 'unset';
            tooltipEl.style.top = `${pos_y}px`;
        });
    }

    handleHideTooltip() {
        this.setState({mpkTooltipVisible: false});
    }

    handleValidForm() {
        this.validator.hideMessages();
        this.props.blockUi(this.createOrUpdate);
    }

    handlePrevBack() {
        if (this.state.activeIndex === 0) {
            this.props.onHide();
        } else {
            this.setState({activeIndex: this.state.activeIndex - 1}, () => {
                this.props.unblockUi();
            });
        }
    }

    prepareFooter() {
        const {t} = this.props;
        return (
            <div className='footer-dialog-button-container card-manage-footer'>
                <ActionButton
                    label={this.state.activeIndex === 0 ? t('details.cancel') : t('details.back')}
                    variant={'button cancel-button white'}
                    handleClick={this.handlePrevBack}
                />
                <ActionButton label={t('details.saveChanges')} variant='button save-button blue' handleClick={this.handleFormSubmit} />
            </div>
        );
    }

    handleFormSubmit(event) {
        const {t} = this.props;
        if (event !== undefined) {
            event.preventDefault();
        }
        if (this.validator.allValid()) {
            if (
                !this.state.element.cardKind ||
                ((this.props.template || this.state.element.template) &&
                    (this.state.element?.name === null || this.state.element?.name === undefined || this.state.element?.name === ''))
            ) {
                this.setState({activeIndex: 0}, () => {
                    this.forceUpdate();
                    this.validator.showMessages();
                });
                return;
            } else if (
                this.state.element?.petrols?.filter((p) => p.selected)?.length === 0 &&
                this.state.element?.services?.filter((p) => p.selected)?.length === 0 &&
                this.state.element?.products?.filter((p) => p.selected)?.length === 0
            ) {
                this.setState({activeIndex: 1}, () => {
                    this.forceUpdate();
                    this.validator.showMessages();
                    this.showErrorMessage(t('error.noProductsSelected'));
                });
                return;
            }
            this.handleValidForm();
        } else {
            this.validator.showMessages();
            // rerender to show messages for the first time
            this.scrollToError = true;
            this.forceUpdate();
        }
    }

    translate(key) {
        const {t} = this.props;
        return t(key);
    }

    renderHeader() {
        const {t} = this.props;
        return (
            <React.Fragment>
                <DivContainer colClass={`col-12`}>
                    <DivContainer colClass='col-12'>
                        <label>
                            {this.props.newTemplate
                                ? `${t('order-card.newTemplateHeader')}`
                                : this.props.template
                                ? `${t('order-card.editTemplateHeader')}: ${this.props.element.name}`
                                : this.props.draft
                                ? `${t('order-card.editOrderHeader')}: ${this.props.element.id}`
                                : `${t('order-card.viewOrderHeader')}: ${this.props.element.id}`}
                        </label>
                    </DivContainer>
                </DivContainer>
            </React.Fragment>
        );
    }

    updateElement(data) {
        this.setState(
            {
                element: OrderCardModel.copy(data),
            },
            () => {
                this.initAfterSetElement();
            }
        );
    }

    setElement() {
        this.props.blockUi();
        if (this.props.element) {
            this.updateElement(this.props.element);
        } else {
            this.initAfterSetElement();
        }
    }

    getContainerListName() {
        return this.props.containerListName;
    }

    createOrUpdate() {
        const {element} = this.state;
        const {t, template, newTemplate} = this.props;
        const request = element;
        this.scrollToTop();
        this.blockUi();
        if (this.props._isMounted) {
            if (newTemplate) {
                this.cardOrderService
                    .saveAsTemplate(request)
                    .then((response) => {
                        if (this.props.afterSave) {
                            this.showSuccessMessage(t('order-card.successSaveAsTemplate'));
                            this.props.afterSave(response);
                        }
                    })
                    .catch((err) => {
                        if (this.props.afterSave) {
                            this.showErrorMessage(t('error.saveAsTemplateError'));
                            this.props.afterSave();
                        }
                    });
            } else if (template) {
                this.service
                    .update(request)
                    .then((response) => {
                        if (this.props.afterSave) {
                            this.showSuccessMessage(t('order-card.successUpdateTemplate'));
                            this.props.afterSave(response);
                        }
                    })
                    .catch((err) => {
                        if (this.props.afterSave) {
                            this.showErrorMessage(t('error.editTemplateError'));
                            this.props.afterSave();
                        }
                    });
            } else {
                request.draft = this.props.draft;
                this.cardOrderService
                    .add(request)
                    .then((response) => {
                        if (this.props.afterSave) {
                            if (this.props.draft) {
                                this.showSuccessMessage(t('order-card.successSaveAsDraft'));
                            } else {
                            }
                            this.props.afterSave();
                        }
                    })
                    .catch((err) => {
                        if (this.props.afterSave) {
                            if (this.props.draft) {
                                this.showErrorMessage(t('error.saveAsDraftError'));
                            } else {
                            }
                            this.props.afterSave();
                        }
                    });
            }
        }
    }

    renderItems(listName) {
        const {t} = this.props;
        let allSelected = false;
        if (this.state.element[listName] && this.state.element[listName].length) {
            this.state.element[listName].forEach((el) => {
                if (el.name === 'ALL' && el.selected) {
                    allSelected = true;
                }
            });
        }
        if (listName === 'petrols') {
            return (
                <div>
                    <div className={`row ${this.props.viewMode === 'VIEW' ? 'fleet-good-group' : 'product-not-fuel-label'}`}>
                        {this.state.element[listName] && this.state.element[listName].length
                            ? this.state.element[listName].map((p, index) => {
                                  const color = p.color ? p.color : 'white';
                                  const fontColor = p.color ? 'white' : '#090E22';
                                  return this.props.viewMode === 'EDIT' ? (
                                      <InputCheckboxComponent
                                          key={`${p.name}-${listName}`}
                                          id={`${index}-${listName}`}
                                          name='selected'
                                          label={t(`products.${p.name}`)}
                                          labelOnRight
                                          value={p.selected}
                                          disabled={(p.name === 'EV' && this.props.element.draft === true && this.props.element.electro === false) || (p.name === 'EV' && this.props.element.template === true && this.props.element.electro === false ) ? true :   false}
                                          validator={this.validator}
                                          onChange={this.handleChange}
                                          viewMode={this.props.viewMode}
                                          validators='not_required'
                                          colClass='col-width-auto'
                                          stateField={`element.${listName}[${index}]`}
                                          grayBorder={false}
                                          transparentBorder
                                          labelClassName={`product-label card-details gray-border`}
                                          labelLeftStyle={{
                                              backgroundColor: `${color}`,
                                              color: `${fontColor}`,
                                              padding: '0 4px 0 4px',
                                              marginLeft: '8px',
                                              lineHeight: '24px',
                                              fontSize: '12px',
                                              height: '24px',
                                              marginBottom: 0,
                                          }}
                                          onAfterStateChange={() => {
                                              if (
                                                  (p.agreementTermPetraId !== null && p.selected === true) ||
                                                  (p.name === 'ALL' && p.selected === true)
                                              ) {
                                                  this.checkIfAgreementTermIsAlreadyAccepted(p);
                                              }
                                              this.setState((prevState) => {
                                                  const updatedElements = prevState.element[`${listName}`].map((item) => {
                                                    if (p.name === 'ALL' && p.selected === true && this.props.element.electro === true) {
                                                        if (item.name !== 'ALL' && item.selected === false) {
                                                            return {...item, selected: true};
                                                        }
                                                    }
                                                    if (p.name === 'ALL' && p.selected === true && this.props.element.electro === false) {
                                                      if (item.name !== 'ALL' && item.name !== 'EV' ) {
                                                          return {...item, selected: true};
                                                      }
                                                  }
                                                      if (p.name === 'ALL' && p.selected === false) {
                                                          if (item.name !== 'ALL' && item.selected === true) {
                                                              return {...item, selected: false};
                                                          }
                                                      }
                                                      if (p.name !== 'ALL' && p.selected === false) {
                                                          if (item.name === 'ALL' && item.selected === true) {
                                                              return {...item, selected: false};
                                                          }
                                                      }
                                                      if (p.name !== 'ALL' && p.selected === true) {
                                                          const elementsWithSelectedTrue = prevState.element[`${listName}`].filter(
                                                              (element) => element.selected === true
                                                          );
                                                          const allSelected =
                                                              elementsWithSelectedTrue.length ===
                                                              prevState.element[`${listName}`].length - 1;
                                                          if (allSelected && item.name === 'ALL' && item.selected === false) {
                                                              return {...item, selected: true};
                                                          }
                                                      }
                                                      return item;
                                                  });
                                                  return {
                                                      element: {
                                                          ...prevState.element,
                                                          [listName]: updatedElements,
                                                      },
                                                  };
                                              });
                                          }}
                                      />
                                  ) : allSelected || p.selected ? (
                                      <label
                                          key={`products-${p.name}-${index}`}
                                          className={`product-label card-details gray-border`}
                                          style={{backgroundColor: `${color}`, color: `${fontColor}`}}
                                      >
                                          {t(`products.${p.name}`)}
                                      </label>
                                  ) : null;
                              })
                            : null}
                    </div>
                    <div className={'row fleet-good-group-banner-fuels'}>
                    {!!this.props.plasticCard && this.state.element[`petrols`].filter((n) => n.name === 'EV')[0]?.selected ? (
                        this.authService.getProfile().agreementType === 'CASH'?
                        <BannerComponent
                            key={'header-banner'}
                            label={t('cards.bannerEvDetailsCashClient')}
                            iconSvg='ico_red_banner_alert_icon'
                            iconSide='left'
                            variant='red-banner'
                        ></BannerComponent> :
                        <BannerComponent
                            key={'header-banner'}
                            label={t('cards.bannerEvDetails')}
                            iconSvg='ico_red_banner_alert_icon'
                            iconSide='left'
                            variant='red-banner'
                        ></BannerComponent>
                    ) : null}
                    </div>
                </div>
            );
        } else {
            return (
                <div className={`row ${this.props.viewMode === 'VIEW' ? 'fleet-good-group' : 'product-not-fuel-label'}`}>
                    {this.state.element[listName] && this.state.element[listName].length
                        ? this.state.element[listName].map((p, index) => {
                              const color = p.color ? p.color : 'white';
                              const fontColor = p.color ? 'white' : '#090E22';
                              return this.props.viewMode === 'EDIT' ? (
                                  <InputCheckboxComponent
                                      key={`${p.name}-${listName}`}
                                      id={`${index}-${listName}`}
                                      name='selected'
                                      label={t(`products.${p.name}`)}
                                      labelOnRight
                                      value={p.selected || allSelected}
                                      disabled={allSelected && p.name !== 'ALL'}
                                      validator={this.validator}
                                      onChange={this.handleChange}
                                      viewMode={this.props.viewMode}
                                      validators='not_required'
                                      colClass='col-width-auto'
                                      stateField={`element.${listName}[${index}]`}
                                      grayBorder={false}
                                      transparentBorder
                                      labelClassName={`product-label card-details gray-border`}
                                      labelLeftStyle={{
                                          backgroundColor: `${color}`,
                                          color: `${fontColor}`,
                                          padding: '0 4px 0 4px',
                                          marginLeft: '8px',
                                          lineHeight: '24px',
                                          fontSize: '12px',
                                          height: '24px',
                                          marginBottom: 0,
                                      }}
                                  />
                              ) : allSelected || p.selected ? (
                                  <label
                                      key={`products-${p.name}-${index}`}
                                      className={`product-label card-details gray-border`}
                                      style={{backgroundColor: `${color}`, color: `${fontColor}`}}
                                  >
                                      {t(`products.${p.name}`)}
                                  </label>
                              ) : null;
                          })
                        : null}
                </div>
            );
        }
    }

    handleChangeStep(e) {
        this.setState({activeIndex: e.index});
    }

    onIndexTemplate(data, props) {
        return props.rowIndex + 1;
    }

    checkBeforeCloseDialog(listName) {
        this.setState((prevState) => {
            let p = this.state.selectedSelectableItem !== undefined ? this.state.selectedSelectableItem : 'ALL';

            const updatedElements = prevState.element[`${listName}`].map((item) => {
                //jesli nie byl zaznaczony all, tylko cos innego
                if (p.name !== 'ALL' && p.selected === true) {
                    //i zaznaczony checkbox ma przypisany regulamin do akceptacji
                    if (item.name === p.name && item.selected === true) {
                        //to odznacz ten przycisk skoro user nie zaakceptowal regulaminu
                        return {...item, selected: false};
                    }
                    if (item.name === 'ALL' && item.selected === true) {
                        //to odznacz ten przycisk skoro user nie zaakceptowal regulaminu
                        return {...item, selected: false};
                    }
                }
                //jesli user zaznaczyl all i dla danego checkboxa jest przypisany regulamin
                if (p.name === 'ALL' && item.selected === true) {
                    ///  let checkedData=  this.checkX(item);
                    let checkIfItemAgreementsAccepted = this.checkOnlyAgreementAcceptation(item);

                    //jesli zaznaczono all
                    if (item.name === 'ALL' && item.selected === true) {
                        if (checkIfItemAgreementsAccepted) {
                            return {...item, selected: true};
                        }
                        //odznacz all
                        if (!checkIfItemAgreementsAccepted) {
                            return {...item, selected: false};
                        }
                    }
                    if (item.name !== 'ALL' && item.selected === true && item.agreementTermFileName !== null) {
                        if (checkIfItemAgreementsAccepted) {
                            return {...item, selected: true};
                        }
                        //odznacz all
                        if (!checkIfItemAgreementsAccepted) {
                            return {...item, selected: false};
                        }
                    }
                    //jesli zaznaczono inny item do ktorego przypisany jest regulamin
                }
                if (item.name !== 'ALL' && item.selected === true && item.agreementTermFileName !== null) {
                    if (p.name === item.name) {
                        return {...item, selected: false};
                    }
                    //odznacz go
                }
                return item;
            });
            return {
                element: {
                    ...prevState.element,
                    [listName]: updatedElements,
                },
            };
        });

        this.setState({
            agreementTermDialog: false,
            selectedAgreementTermFileName: undefined,
            selectedAgreementTermName: undefined,
            selectedSelectableItem: undefined,
            readTerms: false,
        });
    }

    renderDetails() {
        const {t, template, draft} = this.props;

        const items = [
            {label: t('order-card.cardType')},
            {label: t('cards.petrolHeader')},
            {label: t('cards.serviceHeader')},
            {label: t('cards.productsHeader')},
        ];
        if (!template && !draft) {
            items.push({label: t('order-card.cards')});
        }
        return (
            <div>
                <Steps
                    model={items}
                    icons
                    className='margin-bottom-24 col-md-8 col-sm-12'
                    activeIconSrc='/images/ico_steps_check.svg'
                    completedIconsSrc='/images/ico_blue_dot_of_doom.svg'
                    nextIconsSrc='/images/ico_steps_next.svg'
                    onSelect={this.handleChangeStep}
                    activeIndex={this.state.activeIndex}
                    readOnly={false}
                />
                <DivContainer colClass='dashboard'>
                    <DivContainer colClass='col-12 dashboard-link-container card-order limits'>
                        <div className='row row-32'>
                            {this.state.activeIndex === 0 ? this.renderData() : null}
                            {this.state.activeIndex === 1 ? this.renderItems('petrols') : null}
                            {this.state.activeIndex === 2 ? this.renderItems('services') : null}
                            {this.state.activeIndex === 3 ? this.renderItems('products') : null}
                            {this.state.activeIndex === 4 ? this.renderCardList() : null}
                        </div>
                        {this.state.activeIndex >= 1 && this.state.activeIndex !== 4 ? (
                            <div className='row'>
                                <label className='limits-label'>{t('cards.limits')}</label>
                                {this.state.activeIndex === 1 ? this.renderFleetGoodGroupLimit(0, 'quantityLimit') : null}
                                {this.state.activeIndex === 1 ? this.renderFleetGoodGroupLimit(0, 'amountLimit') : null}
                                {this.state.activeIndex === 2 ? this.renderFleetGoodGroupLimit(1, 'amountLimit') : null}
                                {this.state.activeIndex === 3 ? this.renderFleetGoodGroupLimit(2, 'amountLimit') : null}
                            </div>
                        ) : null}
                    </DivContainer>
                </DivContainer>
                {this.state.selectedSelectableItem ? (
                    <CardAgreementTermDialog
                        id={`agreement-term-dialog`}
                        ariaCloseIconLabel={this.translate('dialog.closeDialog')}
                        selectedProductItem={this.state.selectedSelectableItem}
                        selectedPetrolFleetGroups={this.state.element.petrols}
                        visible={this.state.agreementTermDialog}
                        blockUi={this.props.blockUi}
                        unblockUi={this.props.unblockUi}
                        showMessage={this.props.showMessage}
                        resizable={true}
                        className='agreement-term-dialog'
                        key={`agreement-term-dialog`}
                        handleReject={() => {}}
                        onHide={(e) => {
                            this.setState((prevState) => {
                                let p = this.state.selectedSelectableItem !== undefined ? this.state.selectedSelectableItem : 'ALL';
                                let allAgreementTermsAccepted = true;
                                this.state.element.petrols
                                    .filter((el) => el.agreementTermPetraId !== null)
                                    .forEach(
                                        (el) =>
                                            (allAgreementTermsAccepted =
                                                allAgreementTermsAccepted &&
                                                this.authService.isProductAgreementTermAccepted(el.agreementTermPetraId))
                                    );

                                const updatedElements = prevState.element.petrols.map((item) => {
                                    //jesli nie byl zaznaczony all, tylko cos innego
                                    if (
                                        p.name !== 'ALL' &&
                                        p.selected === true        
                                    ) { 
                                        if(!this.authService.isProductAgreementTermAccepted(item.agreementTermPetraId)){
                                        //i zaznaczony checkbox ma przypisany regulamin do akceptacji
                                        if (item.name === p.name && item.selected === true) {    
                                            //to odznacz ten przycisk skoro user nie zaakceptowal regulaminu
                                            return {...item, selected: false};
                                        }
                                        if (item.name === 'ALL' && item.selected === true) {
                                            //to odznacz ten przycisk skoro user nie zaakceptowal regulaminu
                                            return {...item, selected: false};
                                        }
                                    }
                                    if(this.authService.isProductAgreementTermAccepted(item.agreementTermPetraId)){
                                        //i zaznaczony checkbox ma przypisany regulamin do akceptacji
                                        if (item.name === p.name && item.selected === true) {
                                            //to zaznacz ten przycisk skoro user  zaakceptowal regulamin
                                            return {...item, selected: true};
                                        }
                                        if (item.name === 'ALL' && item.selected === true) {
                                            //to zaznacz ten przycisk skoro user  zaakceptowal regulamin
                                            return {...item, selected: true};
                                        }
                                    }                      
                                    }
                                    //jesli user zaznaczyl all i dla danego checkboxa jest przypisany regulamin
                                    if (p.name === 'ALL' && item.selected === true) {
                                        ///  let checkedData=  this.checkX(item);
                                        let checkIfItemAgreementsAccepted = allAgreementTermsAccepted; //this.checkOnlyAgreementAcceptation(item);

                                        //jesli zaznaczono all
                                        if (item.name === 'ALL' && item.selected === true) {
                                            if (checkIfItemAgreementsAccepted) {
                                                return {...item, selected: true};
                                            } else {
                                                //odznacz all
                                                return {...item, selected: false};
                                            }
                                        }
                                        if (item.name !== 'ALL' && item.selected === true && item.agreementTermPetraId !== null) {
                                            if (this.authService.isProductAgreementTermAccepted(item.agreementTermPetraId)) {
                                                return {...item, selected: true};
                                            } else {
                                                //odznacz all
                                                return {...item, selected: false};
                                            }
                                        }
                                        //jesli zaznaczono inny item do ktorego przypisany jest regulamin
                                    }
                                    if (item.name !== 'ALL' && item.selected === true && item.agreementTermFileName !== null) {
                                        if (p.name === item.name) {
                                            return {...item, selected: false};
                                        }
                                        //odznacz go
                                    }
                                    return item;
                                });
                                return {
                                    agreementTermDialog: false,
                                    selectedSelectableItem: undefined,
                                    element: {
                                        ...prevState.element,
                                        petrols: updatedElements,
                                    },
                                };
                            });
                        }}
                        closable={false}
                    ></CardAgreementTermDialog>
                ) : null}
            </div>
        );
    }

    checkIfAgreementTermIsAlreadyAccepted(product) {
        const {t} = this.props;
        let listOfAgreementTermFileNamesAll = this.state.element['petrols']
            .filter((el) => el.agreementTermPetraId !== null)
            .map((el) => el.agreementTermPetraId);
        if (
            listOfAgreementTermFileNamesAll.includes(product.agreementTermPetraId) &&
            !this.authService.isProductAgreementTermAccepted(product.agreementTermPetraId)
        ) {
            this.accountService
                .isAgreementTermAccepted(product.agreementTermPetraId)
                .then((result) => {
                    if (result === false) {
                        console.log('checkIfAgreementTermIsAlreadyAccepted', product);
                        this.unblockUi(
                            this.setState({
                                agreementTermDialog: true,
                                selectedSelectableItem: product,
                            })
                        );
                    }
                })
                .catch(() => {
                    this.unblockUi();
                    this.showErrorMessage(t('error.isAgreementTermAcceptedError'));
                });
        }
        //TODO
        if (product.name === 'ALL') {
            listOfAgreementTermFileNamesAll.forEach((element) => {
                this.accountService
                    .isAgreementTermAccepted(element)
                    .then((result) => {
                        if (result === false) {
                            this.unblockUi(
                                this.setState({
                                    agreementTermDialog: true,
                                    selectedSelectableItem: product,
                                })
                            );
                        }
                    })
                    .catch(() => {
                        this.unblockUi();
                        this.showErrorMessage(t('error.isAgreementTermAcceptedError'));
                    });
            });
        }
    }

    changeRequiredByCardKind() {
        if (this.state.element.cardKind === 'FIRM') {
            this.setState((prevState) => ({
                element: {
                    ...prevState.element,
                    firm: true,
                    vehicle: false,
                    vehiclePerson: false,
                    person: false,
                    vehicleRequired: false,
                    driverRequired: false,
                },
            }));
        } else if (this.state.element.cardKind === 'VEHICLE') {
            this.setState((prevState) => ({
                element: {
                    ...prevState.element,
                    firm: false,
                    vehicle: true,
                    vehiclePerson: false,
                    person: false,
                    vehicleRequired: true,
                    driverRequired: false,
                },
            }));
        } else if (this.state.element.cardKind === 'VEHICLE_PERSON') {
            this.setState((prevState) => ({
                element: {
                    ...prevState.element,
                    firm: false,
                    vehicle: false,
                    vehiclePerson: true,
                    person: false,
                    vehicleRequired: true,
                    driverRequired: true,
                },
            }));
        } else if (this.state.element.cardKind === 'PERSON') {
            this.setState((prevState) => ({
                element: {
                    ...prevState.element,
                    firm: false,
                    vehicle: false,
                    vehiclePerson: false,
                    person: true,
                    vehicleRequired: false,
                    driverRequired: true,
                },
            }));
        }
    }

    renderData() {
        const {t} = this.props;
        return !this.state.loading ? (
            <React.Fragment>
                <DivContainer colClass='row margin-bottom-24'>
                    <InputTextComponent
                        id='draftName'
                        name='name'
                        label={t('order-card.draftName')}
                        colClass='col-md-4 col-sm-12'
                        value={this.state.element.name}
                        placeholder={t('order-fuel.nameYourDraft')}
                        viewMode={this.props.viewMode}
                        validator={this.validator}
                        validators='required'
                        onChange={this.handleChange}
                        rendered={!!this.props.template}
                    />
                    <InputDropdownComponent
                        id='cardKind'
                        name='cardKind'
                        label={t('order-card.cardType')}
                        colClass='col-md-4 col-sm-12'
                        value={this.state.element.cardKind}
                        viewMode={this.props.viewMode}
                        validator={this.validator}
                        validators='required'
                        options={this.state.cardKindOpt}
                        onChange={this.handleChange}
                        dataKey='enumValue'
                        optionLabel='label'
                        optionValue='enumValue'
                        onAfterStateChange={this.changeRequiredByCardKind}
                        enumMode
                        enumName='EcCardKind'
                        valueView={this.props.viewMode === 'VIEW' ? t(`EcCardKind.${this.state.element.cardKind}`) : undefined}
                    />
                    <InputNumberComponent
                        id={'monthlyAmountLimit'}
                        name={'monthlyAmountLimit'}
                        label={t('order-card.monthlyAmountLimitSummary')}
                        value={this.state.element.monthlyAmountLimit}
                        validator={this.validator}
                        validators='not_required'
                        onChange={this.handleChange}
                        viewMode={this.props.viewMode}
                        min={0}
                        colClass='col-md-4 col-sm-12'
                    />
                    <InputNumberComponent
                        id={'dailyVisitLimit'}
                        name={'dailyVisitLimit'}
                        label={t('cards.dailyVisitLimit')}
                        value={this.state.element.dailyVisitLimit}
                        validator={this.validator}
                        validators='not_required'
                        onChange={this.handleChange}
                        viewMode={this.props.viewMode}
                        min={0}
                        colClass='col-md-4 col-sm-12'
                    />
                </DivContainer>
                <div className='row'>
                    <label className={`p-label`}>{t('cards.requiredHeaderLabel')}</label>
                    <InputCheckboxComponent
                        id={'vehicleRequired'}
                        name='vehicleRequired'
                        label={t('cards.registrationNumberFull')}
                        labelOnRight
                        value={this.state.element.vehicleRequired}
                        validator={this.validator}
                        onChange={this.handleChange}
                        viewMode={'EDIT'}
                        validators='not_required'
                        colClass='col-width-auto'
                        disabled={
                            this.props.viewMode === 'VIEW' ||
                            this.state.element.cardKind === 'VEHICLE' ||
                            this.state.element.cardKind === 'VEHICLE_PERSON'
                        }
                    />
                    <InputCheckboxComponent
                        id={'driverRequired'}
                        name='driverRequired'
                        label={t('cards.fullName')}
                        labelOnRight
                        value={this.state.element.driverRequired}
                        validator={this.validator}
                        onChange={this.handleChange}
                        viewMode={'EDIT'}
                        validators='not_required'
                        colClass='col-width-auto'
                        disabled={
                            this.props.viewMode === 'VIEW' ||
                            this.state.element.cardKind === 'PERSON' ||
                            this.state.element.cardKind === 'VEHICLE_PERSON'
                        }
                    />
                    <InputCheckboxComponent
                        id={'odometerRequired'}
                        name='odometerRequired'
                        label={t('cards.odometer')}
                        labelOnRight
                        value={this.state.element.odometerRequired}
                        validator={this.validator}
                        onChange={this.handleChange}
                        viewMode={'EDIT'}
                        validators='not_required'
                        colClass='col-width-auto'
                        disabled={this.props.viewMode === 'VIEW'}
                    />
                    <div className='mpk-div col-width-auto'>
                        <InputCheckboxComponent
                            id={'mpkRequired'}
                            name='mpkRequired'
                            label={t('cards.mpk')}
                            labelOnRight
                            value={this.state.element.mpkRequired}
                            validator={this.validator}
                            onChange={this.handleChange}
                            viewMode={'EDIT'}
                            validators='not_required'
                            colClass='flex-inputs'
                            iconSvg='ico_help_input_label_blue'
                            iconSize='mpk-icon'
                            iconSide='right'
                            disabled={this.props.viewMode === 'VIEW'}
                        />
                        <TooltipComponent
                            id='mpk-tooltip'
                            key='mpk-tooltip'
                            visible={this.state.mpkTooltipVisible}
                            content={t('cards.mpkTooltip')}
                            eventListeners={[
                                {
                                    eventName: 'mouseleave',
                                    fnc: this.handleHideTooltip,
                                    eventElementId: 'ico_help_input_label_blue',
                                },
                                {
                                    eventName: 'mouseenter',
                                    fnc: this.handleShowTooltip,
                                    eventElementId: 'ico_help_input_label_blue',
                                },
                            ]}
                        />
                    </div>
                </div>
            </React.Fragment>
        ) : null;
    }

    renderCardList() {
        const {t} = this.props;
        const {cardList} = this.state.element;
        const agreementLimitedAccess = this.authService.getProfile().limitedAccess === true ? true : false;
        return !this.state.loading ? (
            <React.Fragment>
                <Card header={t('cards.listTitle')}>
                    <DataTable
                        id='dataTable'
                        key='data-table'
                        emptyMessage={this.translate('reports.noColumnsSelected')}
                        className='p-datatable-responsive'
                        responsive
                        breakpoint='0px'
                        value={cardList}
                        sortOrder={-1}
                        rows={cardList.length}
                        lazy={this.props.lazy}
                        onPage={this.handlePage}
                        onSort={this.handleSort}
                        expandedRows={this.state.expandedRows}
                        onRowToggle={this.handleOnRowToggle}
                        onRowExpand={this.handleOnRowExpand}
                        onRowCollapse={this.handleOnRowCollapse}
                        rowExpansionTemplate={this.rowExpansionTemplate}
                        rowClassName={this.props.rowClassName}
                        reorderableColumns
                        onRowReorder={this.onRowReorder}
                    >
                        <Column body={this.onIndexTemplate} header={t('cards.lp')} />
                        <Column field='vehicleRegistration' header={t('cards.registrationNumberFull')} />
                        <Column field='cardNumber' header={t('cards.cardNo')} />
                        <Column field='driver' header={t('cards.fullName')} />
                        <Column field='phoneNumber' header={t('cards.phoneNumber')} />
                        <Column field='accountRole' header={t('order-card.role')} body={(row) => row.accountRole !== null ? t(`AccountRole.${row.accountRole}`) : ""} />
                        <Column field='vehicleType' header={t('order-card.vehicleType')} body={(row) => this.vehicleTypeTemplate(row)} />
                        <Column field='packageNumber' header={t('order-card.packageNumber')} body={(row) => this.packageNumberListTemplate(row)} />
                       {agreementLimitedAccess ? <Column field='limitedAccess' header={t('order-card.limitedAccess')}  body={(row) => (row.limitedAccess ? t(`details.yes`) : t(`details.no`))} /> : null } 
                        <Column
                            field='plastic'
                            header={t('CardType.PLASTIC')}
                            body={(row) => (row.plastic ? t(`details.yes`) : t(`details.no`))}
                        />
                    </DataTable>
                </Card>
            </React.Fragment>
        ) : null;
    }

    vehicleTypeTemplate(rowData){
      let fitOption =   this.state.vehicleTypeOpt.filter(vt => vt.code === rowData.vehicleType);
      let secondOpt = this.state.vehicleTypeOpt.filter(o => o.code === rowData.vehicleType);
      if(fitOption.length > 0 ) {
            return fitOption[0].label;
      } else {
        return '';
      }
  
    }
    packageNumberListTemplate(  rowData) {
        let trackUrl = this.state.packageTrackingUrl !== undefined && this.state.packageTrackingUrl !== null ? this.state.packageTrackingUrl : null;
        let packageNo = rowData.packageNumber !== null ? rowData.packageNumber : "";
        if(rowData !== undefined){
            return(
                         trackUrl !== null && rowData.packageNumber !== null ?   
                            <a
                            href={trackUrl + packageNo}
                            alt={''}
                            target='_blank'
                            rel='noreferrer'
                        ><span> {packageNo} <br/></span>  </a>  :
                        <span> {packageNo} <br/></span>
                 
             )
            
        }
    }
    renderFleetGoodGroupLimit(effectiveActiveIndex, limitType) {
        const {t} = this.props;
        let limitName;
        if (effectiveActiveIndex === 0) {
            if (limitType === 'quantityLimit') {
                limitName = 'fuelQuantityLimit';
            } else if (limitType === 'amountLimit') {
                limitName = 'fuelAmountLimit';
            }
        } else if (effectiveActiveIndex === 2) {
            limitName = 'notFuelAmountLimit';
            limitType = 'amountLimit';
        } else if (effectiveActiveIndex === 1) {
            limitName = 'serviceAmountLimit';
            limitType = 'amountLimit';
        }
        return (
            <div className='col-xl-4 col-lg-4 col-md-6 col-sm-12'>
                {!!this.state.element[limitName] ? (
                    <React.Fragment>
                        <InputCheckboxComponent
                            id={`${limitName}-limit-exist`}
                            name={'limit-exist'}
                            label={t(`cards.${limitType}`)}
                            labelOnRight
                            value={!!this.state.element[limitName].type}
                            validator={this.validator}
                            onChange={(type, params, event) => {
                                let element = this.state.element;
                                if (event.checked) {
                                    element[limitName].type = 'DAILY';
                                    element[limitName].value = 0;
                                } else {
                                    element[limitName].type = undefined;
                                    element[limitName].value = undefined;
                                }
                                this.setState({
                                    element,
                                });
                            }}
                            viewMode={'EDIT'}
                            rendered={this.props.viewMode === 'EDIT'}
                            validators='not_required'
                            colClass='col-12'
                        />
                        <React.Fragment>
                            <InputRadioButtonComponent
                                id={`${limitName}-type`}
                                name='type'
                                colClass='col-12 card-manage-limits'
                                options={[
                                    {enumValue: 'DAILY', label: t('cards.daily')},
                                    {enumValue: 'MONTHLY', label: t('cards.monthly')},
                                ]}
                                value={this.state.element[limitName].type}
                                valueLabel='label'
                                labelOnRight
                                itemColClass={'col-xl-6 col-lg-6 col-md-6 col-sm-6'}
                                onChange={this.handleChange}
                                showLabel={false}
                                validator={this.validator}
                                validators='required'
                                label={t('cards.timeTypeLabel')}
                                viewMode={'EDIT'}
                                rendered={this.props.viewMode === 'EDIT' && !!this.state.element[limitName].type}
                                valueKey='enumValue'
                                stateField={`element.${limitName}`}
                            />
                            <InputNumberComponent
                                id={`${limitName}-value`}
                                name='value'
                                label={t(`cards.${limitType}`)}
                                value={this.state.element[limitName].value}
                                validator={this.validator}
                                validators='required'
                                onChange={this.handleChange}
                                viewMode={'EDIT'}
                                min={0}
                                inputStyle={{width: '100%'}}
                                colClass='col-12'
                                rendered={!!this.state.element[limitName].type && this.props.viewMode === 'EDIT'}
                                placeholder={'0'}
                                stateField={`element.${limitName}`}
                            />
                            <InputTextComponent
                                id={limitName}
                                name={limitName}
                                label={t(`cards.${limitType}`)}
                                value={`${this.state.element[limitName].value} / ${
                                    this.state.element[limitName].type === 'DAILY' ? t('day') : t('month')
                                }`}
                                validator={this.validator}
                                validators='required'
                                onChange={this.handleChange}
                                viewMode={'VIEW'}
                                min={0}
                                inputStyle={{width: '100%'}}
                                colClass='flex-inputs'
                                rendered={!!this.state.element[limitName].type && this.props.viewMode === 'VIEW'}
                            />
                        </React.Fragment>
                    </React.Fragment>
                ) : null}
            </div>
        );
    }
}

CardOrderTemplateDialog.defaultProps = {
    currentUser: undefined,
    viewMode: 'VIEW',
    visible: false,
    template: false,
    newTemplate: false,
    draft: false,
};

CardOrderTemplateDialog.propTypes = {
    backUrl: PropTypes.string,
    cancelUrl: PropTypes.string,
    currentUser: PropTypes.object,
    editUrl: PropTypes.string,
    viewMode: PropTypes.string,
    visible: PropTypes.bool,
    onHide: PropTypes.func,
    afterSave: PropTypes.func,
    elementId: PropTypes.any,
    elementIds: PropTypes.array,
    template: PropTypes.bool,
    newTemplate: PropTypes.bool,
    draft: PropTypes.bool,
    containerListName: PropTypes.string.isRequired,
};

export default withTranslation()(CardOrderTemplateDialog);
